import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      riskScaleAndInterpretation: {
        title: 'Risk Scale and Interpretation',
        footer: 'Latest update of risk scale: ',
        table: 'Table',
        chart: 'Chart',
        from: 'From',
        to: 'To',
        year: 'Year',
        riskGrade: 'Risk Grade',
        riskScore: 'Risk Score',
        riskCategory: 'Risk Category',
        probabilityOfDefault: 'Probability of Default',
        totalScoreRank: 'Total Score: (0-1000 scale)',
        previousScore: 'Previous score',
        change: 'Change',
        pd: 'PD',
        currentScoreBased:
          'Current score based on Financial Statement of the year: ',
        modelSegment: 'Model Segment: ',
        tradeCreditLimitRecommendation: 'Trade Credit Limit Recommendation: ',
      },
      corporateRiskScore: {
        title: 'Corporate Risk Score',
        tooltipTitle:
          'The Corporate Risk Score indicates a company’s likelihood of default, defined as ceasing operations within the next 12 months. Score range from 0 to 1000, with higher values indicating lower default risk. Each score range corresponds to a predefined Probability of Default (PD) based on a standardized Master Scale.',
        historicalChange: 'Historical Change',
        score: 'Score',
        probabilityOfDefault: 'Probability of Default (PD)',
        scoreCompany: 'Score Company',
        scoreModelSegment: 'Score Model Segment',
        indicator: 'Indicator',
        point: 'Point',
        unit: 'Unit',
        compareData: 'Compare data',
        basePeriod: 'Base period',
        previousScore: 'Previous score:',
        previousRiskGrade: 'Previous Risk Grade:',
        previousPD: 'Previous PD:',
        previousRiskCategory: 'Previous Risk Category:',
      },
      riskComponentAnalysis: {
        title: 'Risk Component Analysis',
        compareData: 'Compare data',
        basePeriod: 'Base period',
        comparisonPeriod: 'Comparison period',
        scoreBreakdown: 'Score Breakdown',
        scoreBreakdownTooltip:
          'Score Breakdown illustrates the contribution of various factor groups to a company’s overall risk score, including both financial and non-financial components at the industry and corporate levels. These elements are calculated using our proprietary risk assessment framework, based on historical data and the company’s current information.',
        riskDrivers: 'Risk Drivers',
        score: 'Score',
        contribution: 'Contribution',
        median: 'Median',
        relative: 'Relative',
        relativeContributions: 'Relative Contributions',
        relativeContributionsTooltip:
          'Relative Contribution chart reflects the deviation of each risk factor group’s score compared to the normalized median value of the model segment. This representation highlights the contributing factors and indicates whether the company’s relative position within each factor group is higher or lower compared to the segment benchmark.',
        improvement: 'Improvement',
        deterioration: 'Deterioration',
        segmentMedianScore: 'Segment Median Score',
        noData:
          'This company is in defaulted state. No data available for this period',
        lastestScore: 'Lastest Score',
        comparedData: 'Compared Data',
        basePeriod1: 'Base period:',
        comparisonPeriod1: 'Comparison period:',
        textSelectCompany: 'Please select a company before selecting periods',
      },
      forwardLookingPDTermStructure: {
        title: 'Forward Looking PD Term Structure',
        tooltip:
          'The Probability of Default (PD) Term Structure represents the estimated likelihood that a company may default over various time horizons. It illustrates how default risk evolves over short- and long-term periods, offering a forward-looking view of risk exposure. The term structure also incorporates macroeconomic adjustments to account for anticipated changes in the economic environment, enhancing its relevance for future-oriented risk assessments.',
        yearlyTermStructure: 'Yearly Term Structure',
        year: 'Year',
        years: 'Years',
      },
      distributionOfScore: {
        title: 'Distribution of Score',
        tooltip:
          'The Distribution of Score chart shows the distribution of currently operating companies across risk levels FG-1 through FG-17. Companies in FG-18 are not shown because they have defaulted and are no longer meaningful in assessing the risk distribution of the operating group.',
        byModelSegment: 'By Model Segment',
        byIndustry: 'By Industry',
        byCompanySize: 'By Company Size',
        industryDes: 'Industry: ',
        companySize: 'Company Size: ',
        modelSegment: 'Model Segment: ',
        thisCompany: 'Risk Grade that this company belongs to',
        riskGrade: 'Risk Grade',
        riskLevel: 'Risk Level',
        numberOfCompanies: 'Number of Companies',
        perTotalCompanies: '% of Total Companies',
      },
      commentary: {
        title: 'Commentary',
      },
      corporateLinkageScore: {
        title: 'Corporate Linkage Score',
        companyName: 'Company Name',
        taxCode: 'Tax Code',
        relationship: 'Relationship',
        score: 'Score',
        statementDate: 'Statement Date',
        companySize: 'Company Size',
        industry: 'Main Business',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      riskScaleAndInterpretation: {
        title: 'Thang Điểm Và Diễn Giải Rủi Ro',
        footer: 'Thang điểm rủi ro được cập nhật lần cuối: ',
        table: 'Bảng',
        chart: 'Biểu đồ',
        from: 'Từ',
        to: 'Đến',
        year: 'Năm',
        riskGrade: 'Hạng rủi ro',
        riskScore: 'Điểm rủi ro',
        riskCategory: 'Loại rủi ro',
        probabilityOfDefault: 'Xác suất vỡ nợ',
        totalScoreRank: 'Tổng điểm trên thang: 0 - 1000',
        previousScore: 'Điểm kì trước',
        change: 'Biến động',
        pd: 'PD',
        currentScoreBased:
          'Điểm rủi ro hiện tại lấy từ dữ liệu Báo cáo tài chính năm: ',
        modelSegment: 'Phân khúc mô hình rủi ro: ',
        tradeCreditLimitRecommendation:
          'Hạn mức tín dụng thương mại khuyến nghị: ',
      },
      corporateRiskScore: {
        title: 'Điểm Rủi Ro Doanh Nghiệp',
        tooltipTitle:
          'Điểm rủi ro doanh nghiệp cho biết xác suất vỡ nợ của một doanh nghiệp, được định nghĩa là ngừng hoạt động trong vòng 12 tháng tới. Thang điểm từ 0 đến 1000, với điểm số cao hơn thể hiện rủi ro vỡ nợ thấp hơn. Mỗi khoảng điểm tương ứng với một xác suất vỡ nợ (PD) được chuẩn hóa theo thang điểm chuẩn.',
        historicalChange: 'Biến động điểm số theo thời gian',
        score: 'Score',
        probabilityOfDefault: 'Xác suất vỡ nợ (PD)',
        scoreCompany: 'Điểm số công ty',
        scoreModelSegment: 'Điểm số phân khúc mô hình',
        from: 'Từ',
        to: 'Đến',
        year: 'Năm',
        indicator: 'Chỉ tiêu',
        point: 'Điểm',
        unit: 'Đơn vị',
        previousScore: 'Điểm kì trước: ',
        previousRiskGrade: 'Hạng rủi ro:',
        previousPD: 'Xác suất vỡ nợ:',
        previousRiskCategory: 'Loại rủi ro:',
      },
      riskComponentAnalysis: {
        title: 'Phân Tích Thành Phần Và Nhân Tố Rủi Ro',
        compareData: 'So sánh dữ liệu',
        basePeriod: 'Mốc cơ sở',
        comparisonPeriod: 'Mốc so sánh',
        scoreBreakdown: 'Cấu trúc điểm rủi ro',
        scoreBreakdownTooltip:
          'Cấu trúc điểm rủi ro thể hiện tỷ trọng đóng góp của từng nhóm yếu tố vào điểm rủi ro tổng thể của doanh nghiệp, bao gồm các chỉ số tài chính và phi tài chính ở cấp ngành và cấp công ty. Các thành phần này được tính toán dựa trên mô hình đánh giá rủi ro nội bộ của chúng tôi, sử dụng dữ liệu lịch sử và thông tin hiện tại của doanh nghiệp.',
        riskDrivers: 'Nhân tố rủi ro',
        score: 'Điểm số',
        contribution: 'Mức độ ảnh hưởng với tổng điểm',
        median: 'Trung vị',
        relative: 'Đóng góp tương đối với phân khúc',
        relativeContributions: 'Đóng góp tương đối so với phân khúc',
        relativeContributionsTooltip:
          'Biểu đồ đóng góp tương đối so với phân khúc phản ánh mức độ chênh lệch điểm số của từng nhóm yếu tố rủi ro so với giá trị được chuẩn hóa của trung vị của phân khúc mô hình. Giá trị này giúp làm nổi bật các yếu tố có ảnh hưởng và vị thế tương đối của doanh nghiệp so với phân khúc mô hình trong từng nhóm chỉ tiêu là cao hơn hay thấp hơn.',
        improvement: 'Cải thiện',
        deterioration: 'Suy giảm',
        segmentMedianScore: 'Điểm trung vị phân khúc mô hình',
        noData:
          'Công ty đã phá sản. Dữ liệu của công ty trong giai đoạn này không có sẵn',
        lastestScore: 'Điểm số gần nhất',
        comparedData: 'So sánh dữ liệu',
        basePeriod1: 'Mốc cơ sở:',
        comparisonPeriod1: 'Mốc so sánh:',
        textSelectCompany: 'Vui lòng chọn công ty để lựa chọn các mốc so sánh',
      },
      forwardLookingPDTermStructure: {
        title: 'Cấu Trúc Kỳ Hạn Của Xác Suất Vỡ Nợ Dự Báo',
        tooltip:
          'Cấu trúc kỳ hạn của Xác suất vỡ nợ (PD) thể hiện xác suất ước tính mà một doanh nghiệp có thể rơi vào trạng thái vỡ nợ trong thời hạn khác nhau trong tương lai. Cấu trúc này minh họa sự biến động rủi ro vỡ nợ trong cả ngắn và dài hạn, cung cấp góc nhìn định hướng tương lai về mức độ rủi ro. Đồng thời, cấu trúc này cũng bao hàm các điều chỉnh vĩ mô nhằm phản ánh các thay đổi trong môi trường kinh tế, từ đó hỗ trợ cho việc đánh giá rủi ro trong tương lai.',
        yearlyTermStructure: 'Cấu trúc kỳ hạn theo năm',
        year: 'Năm',
        years: 'Năm',
      },
      distributionOfScore: {
        title: 'Phân Phối Điểm Số',
        tooltip:
          'Biểu đồ Phân phối điểm số thể hiện sự phân bố của các doanh nghiệp đang hoạt động tại thời điểm hiện tại trên các bậc rủi ro từ FG-1 đến FG-17. Các doanh nghiệp thuộc mức điểm FG-18 không được hiển thị vì đã xảy ra sự kiện vỡ nợ và không còn mang nhiều ý nghĩa khi đánh giá cấu trúc phân bổ rủi ro của nhóm doanh nghiệp đang vận hành.',
        byModelSegment: 'Theo phân khúc mô hình',
        byIndustry: 'Theo ngành',
        byCompanySize: 'Theo quy mô doanh nghiệp',
        industryDes: 'Ngành: ',
        companySize: 'Quy mô doanh nghiệp: ',
        modelSegment: 'Phân khúc mô hình: ',
        thisCompany: 'Hạng rủi ro của công ty',
        riskGrade: 'Hạng rủi ro',
        riskLevel: 'Mức độ rủi ro',
        numberOfCompanies: 'Số lượng công ty',
        perTotalCompanies: '% Tỷ trọng',
      },
      commentary: {
        title: 'Nhận Xét',
      },
      corporateLinkageScore: {
        title: 'Điểm Số Các Doanh Nghiệp Có Liên Quan',
        companyName: 'Tên Công ty',
        taxCode: 'Mã số thuế',
        relationship: 'Quan hệ',
        score: 'Điểm',
        statementDate: 'Năm tài chính',
        companySize: 'Quy mô',
        industry: 'Ngành',
      },
    },
  }),
)
